'use client'

import { useRootApiClient } from '@/lib/apis/clients/ApiClientStore'

export default function useApiClient() {
  return useRootApiClient()
}
